import Cookies from 'js-cookie'

const FRONTEND_LANGUAGE_MAP = {
  zh: 'zh',
  'zh-cn': 'zh',
  zh_cn: 'zh',
  en: 'en',
  'en-us': 'en',
  en_us: 'en',
  fr: 'fr',
  'fr-fr': 'fr',
  fr_fr: 'fr'
}

const BACKEND_LANGUAGE_MAP = {
  zh: 'zh_CN',
  en: 'en_US',
  fr: 'fr_FR'
}

export function normalizeLanguageCode(language) {
  if (!language) {
    return ''
  }

  const normalizedLanguage = String(language).trim().replace(/-/g, '_')
  const shortLanguage = FRONTEND_LANGUAGE_MAP[normalizedLanguage.toLowerCase()]

  return shortLanguage || normalizedLanguage.toLowerCase()
}

export function toBackendLanguageCode(language) {
  const normalizedLanguage = normalizeLanguageCode(language)
  return BACKEND_LANGUAGE_MAP[normalizedLanguage] || BACKEND_LANGUAGE_MAP.en
}

export function getSitePortal() {
  return window?.SITE_CONFIG?.portal || ''
}

export function syncRequestContextCookies(language) {
  const portal = getSitePortal()
  const normalizedLanguage = normalizeLanguageCode(language || Cookies.get('language') || Cookies.get('lang'))

  if (portal) {
    Cookies.set('authPortal', portal)
  } else {
    Cookies.remove('authPortal')
  }

  if (normalizedLanguage) {
    Cookies.set('lang', toBackendLanguageCode(normalizedLanguage))
  }
}
